import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref, ref, shallowRef } from "vue"

import ProductCode from "@/components/Common/ProductCode"
import type { CategoriesTreeItem, ExistedProduct } from "@/modules/offers/types/catalog"
import { productCatalogSearch } from "@/services/productCatalogService"
import { getFullImagePath } from "@/utils/cdn"

type Props = {
  message?: string
  showCategories?: boolean
}
type Emits = {
  (e: "showDetails" | "selectExistedProduct", product: ExistedProduct): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChooseExistingProduct',
  props: {
    message: { default: "" },
    showCategories: { type: Boolean, default: false }
  },
  emits: ["showDetails", "selectExistedProduct"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: "showDetails" | "selectExistedProduct", product: ExistedProduct): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { message: string, showCategories: boolean };




const showGallery = inject<Function>("showGallery")

const openGallery = (images: Array<string>) => {
  showGallery?.({
    images
  })
}

const productSearch = shallowRef<string>("")
const productCategorySearch = shallowRef<string>()
const searchTimeout = ref<ReturnType<typeof setTimeout>>()
const isFetching = shallowRef<boolean>(false)
const dataSource = ref<ExistedProduct[]>([])

const getProducts = async ({
  q = productSearch.value,
  category = productCategorySearch.value
} = {}) => {
  if (!q && !category) {
    dataSource.value.length = 0
    isFetching.value = false
    return
  }

  try {
    isFetching.value = true
    const query = { q, category_uuid: category }

    const { data } = await productCatalogSearch({ query, pageSize: 50 })

    dataSource.value = data.results
    searchTimeout.value = null
  } catch {
    dataSource.value = []
  } finally {
    isFetching.value = false
  }
}
const onProductSearch = async () => {
  if (searchTimeout.value) {
    clearTimeout(searchTimeout.value)
    searchTimeout.value = null
  }

  isFetching.value = true
  searchTimeout.value = setTimeout(getProducts, 500)
}

// CHOOSE PRODUCT
const chosenCode = ref<string>()

const chooseProduct = (product: ExistedProduct) => {
  if (chosenCode.value === product.p_code) {
    resetChosenProduct()
    return
  }

  chosenCode.value = product.p_code
}
const resetChosenProduct = () => {
  chosenCode.value = undefined
}

// PRODUCT DETAILS
const showProductDetails = (product: ExistedProduct) => {
  emit("showDetails", product)
}
const selectProductForOffer = (product: ExistedProduct) => {
  emit("selectExistedProduct", product)
}

// CATEGORIES

const categoriesTree = inject<Ref<Array<CategoriesTreeItem>>>(
  "categoriesTree",
  shallowRef<Array<CategoriesTreeItem>>([])
)

expose({
  resetChosenProduct,
  getProducts
})

return { __sfc: true,props, emit, showGallery, openGallery, productSearch, productCategorySearch, searchTimeout, isFetching, dataSource, getProducts, onProductSearch, chosenCode, chooseProduct, resetChosenProduct, showProductDetails, selectProductForOffer, categoriesTree, ProductCode, getFullImagePath }
}

})